import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=611e79d6"
import script from "./Architecture.vue?vue&type=script&lang=js"
export * from "./Architecture.vue?vue&type=script&lang=js"
import style0 from "./Architecture.vue?vue&type=style&index=0&id=611e79d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports